import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { downloadTripsApi } from '../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

let cachedParams = null

function* LOAD({ payload: { params } }) {
  console.log('daaaaaaa')
  cachedParams = params
  const companySelect = localStorage.getItem('app.settings.company')

  console.log('companySelect', companySelect)
  if (!companySelect || companySelect === -1) {
    return
  }

  yield put(request(downloadTripsApi(companySelect, params), actions.LOAD))
}

function* COMPANY_SET() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD), takeEvery('company/save', COMPANY_SET)])
}
